export const HREF = {
  ORDERS: 'orders',
  IMPORTS: 'imports',
  ORDER: 'order/:number',
  ORDER_noParam: 'order',
  DETAILS: 'details',
  PROCESSING: 'processing',
  RESOURCE_UPLOAD: 'upload',
  REFUNDS: 'refunds',
  PRODUCTS: 'products',
  HERO_IMAGES: 'hero-images',
  PROMO_BANNERS: 'promo-banners',
  PAYMENTS: 'payments',
  GENERAL_HOLD: 'general-hold',
};
